module.exports = __webpack_public_path__ + "media/images/arrow_forward_ios-ede5d392a87ddf9353e33d2b31b66ea8.svg";